<template>
  <div>
    <table class="table table table-striped mobile-table">
      <thead>
        <tr>
          <td colspan="6">
            <v-toolbar color="secondary" pa-0>
              <v-toolbar-title class="white--text">From Application</v-toolbar-title>
            </v-toolbar>
          </td>
        </tr>
        <tr>
          <th scope="col"></th>
          <th class="col-lg-1">Quantity</th>
          <th scope="col">Equipment</th>

          <th>Cost (ex)</th>
          <th scope="col">Comment</th>
          <th align="right">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(extension, index) in ipOrderRows" :key="index">
          <td align="center">
            <div v-show="extension.hardwareID">
              <v-icon color="green" title="Saved">check_circle</v-icon>
            </div>
          </td>
          <td>
            <input
              v-model="extension.quantity"
              class="text-right form-control"
              v-validate="{ min_value: 1 }"
              :name="'quantity' + index"
              @change="updateRow(index)"
              readonly
            />
          </td>
          <td>
            <select
              v-if="handsets && handsets.length>1"
              v-model="extension.handsetID"
              class="form-control"
              :name="'handsetID' + index"
              v-validate="'required'"
              @change="onChange(index, extension)"
              disabled="true"
            >
              <option></option>
              <option
                v-for="handset in validHandsets"
                :value="handset.handsetID"
                :key="handset.handsetID"
              >
                {{
                handset.manufacturer ? handset.manufacturer.description : ""
                }}
                {{ handset.model }}
              </option>
            </select>
          </td>

          <!-- <td>{{extension.fromIPOrder}}</td>-->
          <td class="currency">{{ extension.cost | currency }}</td>
          <td>{{ extension.comment }}</td>
          <td class="currency">{{ extension.lineTotal | currency }}</td>
        </tr>
      </tbody>
      <!-- </table>
      <table class="table table table-striped table-bordered mobile-table">-->
      <thead v-if="!isGrenke">
        <tr>
          <td colspan="6">
            <v-toolbar color="secondary" pa-0>
              <v-toolbar-title class="white--text">
                Additional Hardware
                <v-btn round small color="primary" name="addrow" @click="addRow">Add Row</v-btn>
              </v-toolbar-title>
            </v-toolbar>
          </td>
        </tr>
        <tr>
          <th scope="col"></th>
          <th class="col-lg-1">Quantity</th>
          <th scope="col">Equipment</th>

          <th>Cost (ex)</th>
          <th scope="col">Comment</th>
          <th align="right">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(extension, index) in rows" :key="index" v-show="extension.fromIPOrder == false">
          <td>
            <v-layout row>
              <v-icon color="green" title="Saved">check_circle</v-icon>
              <v-icon title="Delete" @click="removeRow(extension)">delete</v-icon>
            </v-layout>
          </td>
          <td
            :class="{
              'text-right': true,
              'text-right danger': errors.has('quantity' + index)
            }"
          >
            <input
              v-model="extension.quantity"
              class="text-right form-control"
              v-validate="{ min_value: 1 }"
              :name="'quantity' + index"
              @change="updateRow(index)"
            />
          </td>
          <td :class="{ '': true, danger: errors.has('handsetID' + index) }">
            <v-autocomplete
              v-model="extension.handsetID"
              :items="validHandsets"
              search-input.sync="model"
              :update:error.sync="addNewContent"
              item-text="model"
              item-value="handsetID"
              auto-select-first
              class="form-control"
              flat
              :name="'handsetID' + index"
              v-validate="'required'"
              box
              @input="onChange(index, extension)"
            >
              <template slot="selection" slot-scope="data">
                {{ data.item.model }} ({{
                data.item.manufacturer.description
                }})
              </template>
              <template slot="item" slot-scope="data">
                <v-list-tile-content>
                  <v-list-tile-title v-html="`${data.item.model}`"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="data.item.manufacturer.description"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>
          </td>
          <td v-if="isFTC(extension.handsetID)">
            <v-text-field v-model="extension.cost" prefix="$" @change="updateRow(index)"></v-text-field>
          </td>
          <td v-else class="currency">{{ extension.cost | currency }}</td>
          <td :class="{ '': true, danger: errors.has('comment' + index) }">
            <v-text-field
              v-model="extension.comment"
              class="form-control"
              :name="'comment' + index"
              :v-validate="isFTC(extension.handsetID) ? '' : 'required'"
            ></v-text-field>
          </td>
          <td class="currency">{{ extension.lineTotal | currency }}</td>
        </tr>
        <!--summary-->
        <tr style="border-top: double">
          <td align="center">Total</td>
          <td>
            <input class="text-right form-control" v-model="sumQuantity" readonly />
          </td>
          <td></td>
          <td></td>

          <td></td>
          <td class="currency">{{ sumLineTotals | currency }}</td>
        </tr>
        <tr style="border-top: double">
          <td align="center"></td>
          <td></td>
          <td></td>
          <td></td>

          <td>Freight:</td>
          <td class="currency">{{ totalFreight | currency }}</td>
        </tr>
        <tr>
          <td class="currency"></td>
          <td></td>
          <td></td>

          <td></td>
          <td>GST:</td>
          <td class="currency">{{ gst | currency }}</td>
        </tr>
        <tr>
          <td class="currency"></td>
          <td></td>
          <td></td>

          <td></td>
          <td>
            <strong>Total {{ isGrenke ? "Finance" : "" }} Amount:</strong>
          </td>
          <td class="currency">
            <strong>
              {{
              (sumLineTotals + totalFreight + gst) | currency
              }}
            </strong>
          </td>
        </tr>
        <tr v-show="isGrenke">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>
            Monthly Finance Payment (ex GST)
            <br />
            <span class="caption">* This amount is included in your ONdesk Plan fee payments</span>
          </td>
          <td class="currency">{{ hardware.hardwareOrder.grenkeMonthly | currency }}</td>
        </tr>
      </tbody>
    </table>

    <v-flex sm12 md12 lg12>
      <v-btn name="sbmt" color="primary" @click="save">Save Hardware</v-btn>
    </v-flex>

    <message-alert :component="hardware.message"></message-alert>
  </div>
</template>
<script>
import { createNamespacedHelpers, mapGetters } from "vuex";
import { mapIPVoiceFields } from "@/store/modules/orders";
import { mapHardwareMultiRowFields } from "@/store/modules/orders";
const {
  mapActions: mapHardwareActions,
  mapMutations: mapHardwareMutations
} = createNamespacedHelpers(`orders/hardware`);
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const { mapState: mapIPVoiceState } = createNamespacedHelpers(`orders/ipVoice`);
import { httpError } from "../models/httpError";
export default {
  data () {
    return {
      delRow: false,
      ipOrderRows: [],
      isEditing: false,
      isFreeTypeCharge: false
    };
  },

  methods: {
    ...mapHardwareActions([
      "addHandset",
      "updateHandset",
      "getHandsets",
      "getHardware",
      "setMessage",
      "saveHardware",
      "saveHandsets",
      "deleteRow",
      "getHandsetsOnOrder"
    ]),
    ...mapHardwareMutations(["addRow", "clearRows"]),
    copyDown: function (column) {
      let vm = this;
      for (var i = 1; i < vm.rows.length; i++) {
        vm.rows[i][column] = vm.rows[0][column];
      }
      return;
    },
    addNewContent (val) {
    },
    removeRow (val) {
      this.$dialog
        .confirm("Are you sure you want to delete?")
        .then(async () => {
          await this.deleteRow(val.hardwareID);
        })
        .catch(() => { });
    },
    isFTC (id) {
      let ftcID = this.handsets
        .filter(e => e.model === "Free Type Charge")
        .map(x => x.handsetID);
      if (ftcID.some(x => x === id)) return true;
      else return false;
    },
    onChange: function (index, data) {
      this.rows[index].cost = this.handsets.filter(
        e => e.handsetID == data.handsetID
      )[0].rrpEx;
      this.updateRow(index);
    },
    updateRow: function (index) {
      this.rows[index].lineTotal =
        this.rows[index].quantity * this.rows[index].cost;
    },

    checkPlan: function (ratePlan) {
      return (
        ratePlan.usageType.includes("VoIP") &&
        ratePlan.dealerSupplied == this.dealerSupplied &&
        ratePlan.mixnMatch !== this.minMonthly &&
        (!this.isResidential ? ratePlan.residential == false : 1 == 1)
      );
    },
    async save () {
      let vm = this;
      vm.$validator
        .validateAll()
        .then(async result => {
          if (result) {
            try {
              let hw = await vm.saveHardware();
              let hand = await vm.saveHandsets();
              Promise.all([hw, hand]).then(() => {
                vm.getHardware().then(() => {
                  vm.$emit("saved");
                });
              });
            } catch (err) {
              vm.setMessage({ message: err, httpStatus: 500 });
            }
          } else {
            vm.setMessage({
              message: "Unable to save: Check the highlighted fields above",
              httpStatus: 500
            });
          }
        })
        .catch(function (err) {
          vm.setMessage({ message: err, httpStatus: 500 });
        });
    },
    validRatePlans: function (months) {
      return this.ratePlans
        .filter(this.checkPlan)
        .filter(e => (!this.minMonthly ? e.contractMonths == months : 1 == 1)); // && e.dealerSupplied === this.dealerSupplied);
    }
  },
  computed: {
    ...mapGetters("orders", ["isQantas", "isGrenke"]),
    ...mapIPVoiceFields({ isRental: "iporder.rental" }),
    ...mapIPVoiceState(["iporder"]),
    ...mapHardwareMultiRowFields(["rows", "handsets"]),
    ...mapOrderState({
      hardware: "hardware",
      isResidential: "isResidential"
    }),
    validHandsets () {
      return this.handsets
        .filter(x => (this.isRental ? x.rental == this.isRental : true))
        .sort(function compare (a, b) {
          if (a.manufacturer && a.manufacturer.description) {


            if (
              a.manufacturer.description.toLowerCase() <
              b.manufacturer.description.toLowerCase()
            )
              return -1;
            if (
              a.manufacturer.description.toLowerCase() >
              b.manufacturer.description.toLowerCase()
            )
              return 1;
            return 0;
          }
        });
    },
    sumQuantity () {
      let quantities = this.rows
        .filter(row => row.cost > 0)
        .map(row => row.quantity);

      if (quantities.length > 0) {
        return quantities.reduce((acc, cur) => parseInt(acc) + parseInt(cur));
      } else return 0;
    },
    totalFreight () {
      if (this.rows.length > 0) {
        if (this.sumLineTotals == 0.0) {
          return 0.0;
        }
        return ((this.sumQuantity - 1) * 7.5 + 20.0) * (1 / 1.1);
      } else return 0.0;
    },
    sumLineTotals () {
      if (this.rows && this.rows.length > 0)
        return (
          this.rows
            //.filter(row => row.cost !== 0)
            .map(row => row.lineTotal)
            .reduce((prev, next) => prev + next)
        );
      else return 0;
    },
    gst () {
      return (this.sumLineTotals + this.totalFreight) / 10;
    }
  },
  mounted () {
    let vm = this;
    //vm.clearRows();
    vm.setMessage(new httpError());
    vm.getHandsetsOnOrder().then(data => {
      if (data) {
        //vm.ipOrderRows = data.lines.filter(x => x.fromIPOrder === true);
        vm.ipOrderRows = data.lines;
      }
      vm.getHandsets().then(() => {
        vm.$emit("loaded");
      });
    });
  }
};
</script>
<style scoped>
table.table tbody td,
table.table tbody th {
  height: 100%;
}
.currency {
  text-align: right;
}
</style>
